import * as Yup from 'yup'

export const GenerateMfaSchema = Yup.object({
  deliveryMethod: Yup.string().required(),
})

export type GenerateMfaValues = Yup.InferType<typeof GenerateMfaSchema>
